import React from 'react'
import {
    Row,
    Col,
    Card, 
    CardHeader, 
    CardBody, 
    CardTitle, 
 } from 'reactstrap';
 import MachineCardContent from '../MachineCardContent';

function Index(props) {

    let firstTitle = props.firstTitle;
    let secondTitle = props.secondTitle;
 
    return (
        <div>
            <Row>
                <Col xs={12}>
                    <Card>     
                        <CardHeader>
                            <div className="d-flex justify-content-center align-items-center">
                                <CardTitle tag="h4">
                                    <b> {firstTitle} </b>
                                </CardTitle>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="d-flex justify-content-center align-items-center mt-2">
                                <CardTitle tag="h6">
                                    <b> {secondTitle} </b>
                                    <hr />
                                </CardTitle>
                            </div>
                            <div>
                                <Row>
                                    <div className="d-flex justify-content-center align-items-center mt-2">
                                        <MachineCardContent
                                            firstTitle = {firstTitle}
                                            secondTitle ={secondTitle}
                                        />
                                    </div> 
                                </Row>
                            </div>                                         
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            
        </div>
    )
}
export default Index;